import React from 'react';
import { Table, Badge, Collapse, Button } from 'react-bootstrap';

function CompletedProgramsTable({ completedPrograms, isExpanded, onToggleExpand }) {
  if (completedPrograms.length === 0) {
    return null;
  }

  return (
    <div className="completed-programs-section mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4>
          <i className="fas fa-check-circle me-2 text-success"></i>
          Completed Programs
        </h4>
        <Button
          variant="outline-secondary"
          size="sm"
          onClick={onToggleExpand}
        >
          {isExpanded ? (
            <>
              <i className="fas fa-chevron-up me-1"></i>
              Collapse
            </>
          ) : (
            <>
              <i className="fas fa-chevron-down me-1"></i>
              Expand ({completedPrograms.length})
            </>
          )}
        </Button>
      </div>

      <Collapse in={isExpanded}>
        <div className="table-responsive">
          <Table hover className="completed-programs-table">
            <thead>
              <tr>
                <th>Program Name</th>
                <th>Started</th>
                <th>Completed</th>
                <th>Workouts</th>
              </tr>
            </thead>
            <tbody>
              {completedPrograms.map((cp) => (
                <tr key={cp.id}>
                  <td>
                    <strong>{cp.program_name}</strong>
                  </td>
                  <td>
                    {new Date(cp.program_start_date).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
                  </td>
                  <td>
                    {cp.completed_at ? new Date(cp.completed_at).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : 'N/A'}
                  </td>
                  <td>
                    <Badge bg="info">{cp.workouts_completed || 0} completed</Badge>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </Collapse>
    </div>
  );
}

export default CompletedProgramsTable;
